// -----------------------------------------------------------------------------
// 2) src/components/FavoriteButton.jsx
// -----------------------------------------------------------------------------
import React from "react";
import { api } from "../lib/api";
import EngagementAuthDialog from "./EngagementAuthDialog";
import { isEngagementAuthError } from "./engagementAuthNotice";

export function FavoriteButton({ target, objectId, initial = false, onChange }) {
  const [fav, setFav] = React.useState(!!initial);
  const [busy, setBusy] = React.useState(false);
  const [authDialogOpen, setAuthDialogOpen] = React.useState(false);

  React.useEffect(() => {
    setFav(!!initial);
  }, [initial]);

  async function toggle() {
    if (busy) return;
    setBusy(true);
    try {
      if (!fav) {
        await api.postJson("/engagement/favorites/", { target, object_id: objectId });
        setFav(true);
        onChange && onChange(true);
      } else {
        // Simple delete-by-resubmitting is fine if your backend exposes an id; here we re-post to toggle off via a convenience endpoint.
        // If you later expose DELETE /engagement/favorites/{id}, store that id in state and use it here.
        await api.delete(`/engagement/favorites/?target=${target}&object_id=${objectId}`);
        setFav(false);
        onChange && onChange(false);
      }
    } catch (e) {
      console.warn("favorite toggle failed", e);
      if (isEngagementAuthError(e)) {
        setAuthDialogOpen(true);
        return;
      }
      alert(e.message || "Unable to toggle favorite");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button onClick={toggle} disabled={busy}
        title={fav ? "Remove from favorites" : "Add to favorites"}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: 24,
          width: 24,
          padding: 0,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: 1,
        }}>
        <span aria-hidden="true" style={{ color: fav ? "#dc2626" : "#111827" }}>{fav ? "♥" : "♡"}</span>
      </button>
      <EngagementAuthDialog open={authDialogOpen} onClose={() => setAuthDialogOpen(false)} />
    </>
  );
}
